export interface ChunkedMessage {
  type: 'chunk' | 'complete';
  chunkId: string;
  requestId: string;
  sequence: number;
  totalChunks: number;
  data: string; // Base64 encoded compressed chunk
  originalSize?: number; // Only on first chunk
  compressed?: boolean; // Only on first chunk
}

export interface ChunkMetadata {
  requestId: string;
  totalChunks: number;
  receivedChunks: Set<number>;
  chunks: Map<number, string>;
  originalSize: number;
  compressed: boolean;
  timestamp: number;
}

// Configuration for utility methods
export const WEBSOCKET_CONFIG = {
  // Set to 30KB to stay well under the 32KB frame limit
  MAX_MESSAGE_SIZE: 30 * 1024,
  // Each chunk will be 20KB to account for base64 encoding overhead (4/3 expansion)
  // 20KB * 4/3 = ~26.7KB, leaving room for JSON envelope
  CHUNK_SIZE: 20 * 1024,
  // Cleanup incomplete chunks after 5 minutes
  CHUNK_TIMEOUT_MS: 5 * 60 * 1000,
  // Enable compression for messages over 5KB
  COMPRESSION_THRESHOLD: 5 * 1024,
};

/**
 * Generate a unique chunk ID for a chunked message session
 */
export function generateChunkId(): string {
  return `chunk_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Check if a message needs chunking based on size
 */
export function needsChunking(data: string): boolean {
  return new Blob([data]).size > WEBSOCKET_CONFIG.MAX_MESSAGE_SIZE;
}

/**
 * Calculate the number of chunks needed for a given data size
 */
export function calculateChunks(dataSize: number): number {
  return Math.ceil(dataSize / WEBSOCKET_CONFIG.CHUNK_SIZE);
}
